// Dont statically import elements because we're importing theme stuff that only works on client and this file is imported in isomorphic files
export async function bhPromptConfirmParticipationRemove(opFunction: () => Promise<boolean>) {
  const { XSnackbar } = await import('@adornis/chemistry/elements/components/x-snackbar.js');
  const { XDialog } = await import('@adornis/dialog/x-dialog.js');

  if (!(await XDialog.confirm('Wirklich die Teilnahme löschen?'))) return;

  const res = await opFunction();

  if (res) XSnackbar.show('Erfolgreich gelöscht.');
  else XSnackbar.show('Konnte leiteder nicht gelöscht werden.');

  return res;
}
